import { GET_GALLERY, GALLERY_ERROR } from "../actions/types";

const initialState = {
  galleries: [],
  loading: true,
  error: {}
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_GALLERY:
      return {
        ...state,
        galleries: payload,
        loading: false
      };
    case GALLERY_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
};
